import { formatDistanceToNowStrict } from 'date-fns';
import { CmsPost } from 'graphql/generated';
import { Post } from '../interfaces/post.interface';

export function formatPostData(data: CmsPost): Post{
  const d: Post = { ...data, squareThumbnail: '', thumbnails: [], publishDuration: formatDistanceToNowStrict(new Date(data.publishedAt)) };

  d.postExt?.forEach(({ extType, file }: any) => {
    const u = (file?.publicUrl?? '').replace(/ /g, '%20');
    
    if (extType === 'SQUARE_THUMBNAIL_IMAGE') d.squareThumbnail = u;
    else if (extType === 'THUMBNAIL_IMAGE') {
      d.thumbnails?.push(file?.publicUrl?? '');
    }
  });
  return d;
}
